<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Список пользователей</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">
        <b-button variant="success"
                  style="margin-right: 15px"
                  v-if="isAdmin()"
                  @click="onClickImportUsers()">
          Импортировать пользователей
        </b-button>

        <a class="btn btn-success" href="/users/0" v-if="isAdmin()">
          Добавить
        </a>
      </div>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по ИИН"
                       id="iin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="university" class="form-label col-md-3">
              ВУЗ
            </label>
            <div class="col-md-9">
              <multiselect
                  v-model="page.filter.university"
                  :options="universities"
                  :searchable="true"
                  :closeOnSelect="true"
                  label="nameRu"
                  track-by="universityId"
                  :close-on-select="true"
                  :allow-empty="true"
                  placeholder="Выберите ВУЗ"
                  :multiple="false"
                  :clear-on-select="true"
                  @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
              />
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="role" class="form-label col-md-3">
              Роль
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.role" id="role"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="role in roles" :key="role.id" :value="role.id" :title="role.description">
                  {{ role.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(iin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('iin')"
             :class="{'ascending': page.sort.iin === 'ASC', 'descending': page.sort.iin === 'DESC'}">
          ИИН
        </div>
      </template>
      <template #head(lastName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('lastName')"
             :class="{'ascending': page.sort.lastName === 'ASC', 'descending': page.sort.lastName === 'DESC'}">
          Фамилия
        </div>
      </template>
      <template #head(firstName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('firstName')"
             :class="{'ascending': page.sort.firstName === 'ASC', 'descending': page.sort.firstName === 'DESC'}">
          Имя
        </div>
      </template>
      <template #head(patronymic)="data">
        <div class="sortable-container none"
             @click="onSortChanged('patronymic')"
             :class="{'ascending': page.sort.patronymic === 'ASC', 'descending': page.sort.patronymic === 'DESC'}">
          Отчество
        </div>
      </template>
      <template #head(roles)="data">
        <div class="sortable-container none"
             @click="onSortChanged('roles')"
             :class="{'ascending': page.sort.roles === 'ASC', 'descending': page.sort.roles === 'DESC'}">
          Роль
        </div>
      </template>
      <template #head(actions)="data" v-if="isAdmin()">
      </template>


      <template #cell(iin)="data">
        {{ data.item.iin }}
      </template>
      <template #cell(lastName)="data">
        <a :href="`/users/${data.item.id}`">
          {{ data.item.lastName }}
        </a>
      </template>
      <template #cell(firstName)="data">
        <a :href="`/users/${data.item.id}`">
          {{ data.item.firstName }}
        </a>
      </template>
      <template #cell(patronymic)="data">
        <a :href="`/users/${data.item.id}`">
          {{ data.item.patronymic }}
        </a>
      </template>
      <template #cell(roles)="data">
        {{ getRoleNames(data.item.roles) }}
      </template>
      <template #cell(actions)="data" v-if="isAdmin()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Импорт пользователей" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="fileUpload" class="form-label">
          Файл с данными (*.csv)
          <span class="text-danger">*</span>
        </label>
        <div class="col-md-9">
          <input type="file" id="fileUpload" @change="handleFileUpload" accept=".csv" class="form-control"/>
        </div>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import userService from "@/services/userService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import {RoleEnum} from "@/enum/RoleEnum";
import delegationService from "@/services/delegationService";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      page: {
        filter: {
          search: null,
          universityId: null,
          role: null
        },
        sort: {
          iin: null,
          lastName: null,
          firstName: null,
          patronymic: null,
          roles: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'iin', label: 'ИИН', sortable: true},
        {key: 'lastName', label: 'Фамилия', sortable: true},
        {key: 'firstName', label: 'Имя', sortable: true},
        {key: 'patronymic', label: 'Отчество', sortable: true},
        {key: 'roles', label: 'Роль', sortable: true},
        {key: 'actions', label: '', sortable: false}
      ],
      items: [],
      universities: [],
      roles: []
    };
  },
  methods: {
    getRoleNames(roles) {
      const roleMap = {
        ROLE_VO_ADMIN: "Админ ФЦ",
        ROLE_VO_ADMIN_READ_ONLY: "Админ ФЦ(Просмотр)",
        ROLE_VO_MANAGER: "Менеджер ФЦ",
        ROLE_VO_UNIVERSITY: "Менеджер ВУЗа",
        ROLE_VO_ACCOUNTANT: "Бухгалтерия ФЦ",
        ROLE_VO_RECTOR: "Ректор ВУЗа"
      };
      return roles
          .map(role => roleMap[role] || role)
          .join(", ");
    },
    async reloadList() {
      this.isLoading = true;
      const response = await userService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await userService.deleteById(item.id);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initRoles() {
      this.roles = [];

      for (const id in RoleEnum) {
        const role = {
          id: id,
          name: RoleEnum[id].name,
          description: RoleEnum[id].description,
        };
        this.roles.push(role);
      }
    },
    onClickImportUsers() {
      this.uploadedFile = null;
      this.showModal = true;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    async submitForm() {
      if (!this.uploadedFile) {
        showErrorNotify("Убедитесь, что все обязательные поля заполнены");
        return;
      }

      this.isLoading = true;

      try {
        const formData = new FormData();
        formData.append('file', this.uploadedFile);

        await userService.uploadUsersCsv(formData);

        this.reloadList();

        showSuccessNotify("Файл успешно загружен");
        this.showModal = false;
      } catch (error) {
        showErrorNotify("Ошибка при загрузке файла");
      } finally {
        this.isLoading = false;
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    }
  },
  mounted() {
    this.reloadList();
    this.initUniversities();
    this.initRoles();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
